import BlogThirtyOneContainer from "./container/BlogThirtyOneContainer";
export default BlogThirtyOneContainer;
